export const createIssueEventExternalUrl = (issueBaseUrl: string, databaseId: number | null) =>
  `${issueBaseUrl}#event-${databaseId}`
